import { Text } from '@/core/tamagoshi/Text/Text';

import { createYourAccountWelcomeOfferExpired } from './translations';

export default function DiscoutWelcomeOfferExpiredText() {
  return (
    <>
      {createYourAccountWelcomeOfferExpired.format({
        strong: (chunks) => (
          <Text
            tag="span"
            weight="bold"
            key="expired-welcome-offer"
            data-testid="expired-suspected-pro-coupon"
          >
            {chunks}
          </Text>
        ),
      })}
    </>
  );
}
